import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Modal from 'react-native-modal';
import { useWindowDimensions, Image, FlatList, Platform } from 'react-native';
import * as Animatable from 'react-native-animatable';
import styles from '@stylesheet';
import { Text, View, Title, BlurView, ScrollView, StyledModal, StyledModalHandle } from '@constants/Themed';
import Button from '@components/UI/Button/Button';
import useGlobalUser from '@hooks/getGlobalUser';
import { useNavigation } from '@react-navigation/native';
import { Entypo, AntDesign } from '@expo/vector-icons';
import moment from 'moment';
import toTitleCase from '@hooks/toTitleCase';
import RowComponent from '../../Global/RowComponent/RowComponent';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import BottomSheet from '@gorhom/bottom-sheet';
import parseByDelimiter from '@utils/parseByDelimiter';
import SvgQRCode from 'react-native-qrcode-svg';
import * as Linking from 'expo-linking';
import apis from '@api/api';
import LoadingIndicator from '../../Global/Spinner';
// import EmailComposeModal from "./EmailComposeModal/EmailCompose";


interface DataItem {
  _id: string;
  dataTitle: string;
  createdAt: string;
  owner?: {
    profile_information: {
      avatar: {
        img: string;
      };
      name: string;
      surname: string;
    };
  };
  participants?: any[];
}

interface DataOptionsType {
  title?: string;
  refreshFunction?: Function;
  participants?: Object[];
}

export interface DataOptionsModalHandle {
  openModal: (item: DataItem) => void;
}

const DataOptionsModal = forwardRef<DataOptionsModalHandle, DataOptionsType>((props, ref) => {
  const [item, setItem] = useState<DataItem | null>(null);
  const { refreshFunction, participants } = props;
  const windowDimensions = useWindowDimensions();
  const [confirmState, setConfirmState] = useState("");
  const globalUser = useGlobalUser();
  const theme = themeSelector();
    const emailComposeRef = useRef<BottomSheet>(null);
  const { width, height } = useWindowDimensions();
  const [qrCode, setQrCode] = useState(false);
  const [qrValue, setQrValue] = useState('');
  const handleOpenEmailCompose = useCallback(() => {
    if (emailComposeRef.current) {
      (emailComposeRef.current as any).expand?.();
    }
  }, [emailComposeRef]);
  const navigation = useNavigation();
  const [visibleState, setState] = useState(false);
  const [loading, setLoading] = useState(false);
  const styleModalRef = useRef<StyledModalHandle>(null);

  useImperativeHandle(ref, () => ({
    openModal: (item) => {
      setItem(item);
      styleModalRef.current?.openModal?.();
    }
  }));

  const handleDeleteFunction = async () => {
    console.log('attempting something', globalUser, item._id);
  };

    useEffect(() => {
      if (emailComposeRef) {
        emailComposeRef.current?.expand();
      }
    }, [emailComposeRef]);

  const generateQR = useCallback(() => {
    if (item) {
      const url = Linking.createURL(`/form/${item._id}`, { queryParams: { dataTitle: item.dataTitle } })
      setQrValue(url)
    }
  }, [item]);


  const _handleMakePublic = useCallback(async () => {
    if (!item) return;
    setLoading(true)
    await apis.makeDataPublic(item._id).catch(err => { console.error(err); setLoading(false) });
    setLoading(false)
  }, [item])

  const handleEditModel = useCallback(() => {
    //Dispatch to store and navigate directly to data handler screen
    //ensure that history is also refreshed first. 
    //Add var in store that shows its a current model with model id
    //Update model with changes for future entries
    //Convert schema to array?
  }, [item]);

  const Participant = ({ item, index }) => {
    return (
      <View style={{ flexDirection: 'row', gap: 10 }}>
        <Text>{index + 1}.</Text>
        <Text>{toTitleCase(item?.profile_information?.name)} {toTitleCase(item?.profile_information?.surname)}</Text>
      </View>
    )
  }


  if (!item) return null;

  return (
    <StyledModal
      ref={styleModalRef}
      title={Platform.OS != 'web' ? parseByDelimiter(item.dataTitle) : undefined}
      caption={Platform.OS != 'web' ? `Actions for ${parseByDelimiter(item.dataTitle)}` : undefined}
      customContent={Platform.OS === 'web' ? (
        <Animatable.View transition={'flex'} style={{ backgroundColor: "transparent", paddingVertical: 50, flex: qrCode ? 2 : 1, gap: 20, }}>
          <View style={[styles.centerEverything, { flex: 1, backgroundColor: "transparent", maxHeight: 50, marginVertical: -20, flexDirection: 'row', gap: 20, justifyContent: 'center' }]}>
            <AntDesign name="setting" size={25} color="white" style={{ textAlign: 'center', verticalAlign: 'middle', justifyContent: 'center' }} />
            <Title style={{ color: "white" }}>{toTitleCase(parseByDelimiter(item.dataTitle))}</Title>
          </View>
          <View style={[styles.centerEverything, { backgroundColor: "transparent", flex: 1, flexDirection: "row" }]}>
            <Image source={{ uri: item.owner?.profile_information.avatar.img }} style={{ resizeMode: 'contain', borderRadius: 40, flex: 1, height: 80, width: 60, left: -10, top: -5 }} />
            <View style={{ flex: 3, padding: 10, left: -10, backgroundColor: 'transparent' }}>
              <Text style={{ color: "white" }}>Owner</Text>
              <Text style={{ fontWeight: '600', fontSize: 16, color: "white" }}>{toTitleCase(item.owner?.profile_information.name)} {toTitleCase(item.owner?.profile_information.surname)}</Text>
              <Text style={{ color: "white" }}>Created: {moment(item.createdAt).format("ddd DD MM YYYY HH:MMa")}</Text>
            </View>
          </View>
          {
            qrCode &&
            <Animatable.View useNativeDriver animation={'fadeIn'} style={{ flex: 1 }}>
              <Text style={{ textAlign: "center", color: "white" }}>Easily share forms with anyone using the QR code below</Text>
              <View style={{ flex: 1, alignSelf: 'center', justifyContent: 'center', backgroundColor: "transparent" }}>
                <SvgQRCode size={200} value={qrValue} />
              </View>
            </Animatable.View>
          }
        </Animatable.View >
      ) : null}
    >
      <View style={{ flexDirection: windowDimensions.width > 500 ? 'row' : 'column', minHeight: Platform.OS === 'web' ? undefined : 500 }}>
        <View style={{ flex: 1, gap: 20, paddingVertical: Platform.select({ web: 20, default: 10 }) }}>
          {Platform.OS !== 'web' && (
            <View style={{ gap: 10, marginBottom: 20 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                {item.owner?.profile_information?.avatar?.img && (
                  <Image
                    source={{ uri: item.owner.profile_information.avatar.img }}
                    style={{ width: 50, height: 50, borderRadius: 25 }}
                  />
                )}
                <View style={{ flex: 1 }}>
                  <Text style={{ fontWeight: '600', fontSize: 16 }}>
                    {toTitleCase(item.owner?.profile_information?.name)} {toTitleCase(item.owner?.profile_information?.surname)}
                  </Text>
                  <Text style={{ fontSize: 12, opacity: 0.7 }}>
                    Created: {moment(item.createdAt).format("DD MMM YYYY")}
                  </Text>
                </View>
              </View>
            </View>
          )}

          {
            item?.participants?.length > 1 &&
            <View style={{ marginBottom: 20 }}>
              <Title style={{ textAlign: 'left', marginBottom: 10 }}>Participants</Title>
              <FlatList
                  data={item?.participants}
                nestedScrollEnabled
                  ListEmptyComponent={(
                    <View>
                      <Text>No participants on this dataset. You can invite users using the share button.</Text>
                    </View>
                  )}
                  renderItem={({ item, index }) => (<Participant item={item} index={index} />)}
                />
              </View>
          }

          <ScrollView
            style={{ flex: 1 }}
            nestedScrollEnabled
            showsVerticalScrollIndicator={false}
          >
            {
              !loading ?
                <View style={{ gap: 10, paddingBottom: 20 }}>
                  <RowComponent
                    title={"Edit Model"}
                    buttonText="Edit Model"
                    subtitle={"Make changes to your capture model"}
                    icon={"edit"}
                    onPress={() => {
                      styleModalRef.current?.closeModal();                        
                      (navigation as any).navigate('Data', { screen: 'DataHandler', params: { id: `${item?._id.toString()}` } });
                    }}
                  />
                  <RowComponent
                    title={"Send group email"}
                    buttonText="Send email"
                    subtitle={"Quickly send personalised email to all stored contacts under a data model"}
                    icon={"mail"}
                    onPress={() => handleOpenEmailCompose()}
                  />
                  <RowComponent
                    title={"Send group WhatsApp"}
                    buttonText="Send message"
                    subtitle={"Quickly send personalised messages to all stored contacts under a data model"}
                    icon={"phone"}
                    onPress={() => alert('WhatsApp integration coming soon!')}
                  />
                  <RowComponent
                    title={qrCode ? "Hide QR Code" : "View QR Code"}
                    buttonText={qrCode ? "Hide QR Code" : "View QR Code"}
                    subtitle={"Allow anyone to quickly enter form data by sharing a QR code"}
                    icon={"qrcode"}
                    onPress={() => { if (!qrCode) { generateQR() } setQrCode(!qrCode) }}
                  />
                  {qrCode && (
                    <View style={{ alignItems: 'center', padding: 20, backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: 10, marginVertical: 10 }}>
                      <Text style={{ textAlign: "center", marginBottom: 15 }}>
                        Easily share forms with anyone using the QR code below
                      </Text>
                      <SvgQRCode size={200} value={qrValue} />
                    </View>
                  )}
                  <RowComponent
                    title="Make data public"
                    buttonText='Make model public'
                    subtitle='Make your data model accessible to the public, allowing anyone to contribute.'
                    icon="cloud-sync"
                    onPress={_handleMakePublic}
                  />
                  <RowComponent
                    title="Clear data content"
                    subtitle='Remove all the data from your data model. This action is not reversible.'
                    icon="delete"
                    buttonColor='red'
                    buttonText='Clear model'
                    onPress={handleDeleteFunction}
                  />
                </View>
                :
                <LoadingIndicator />
            }
          </ScrollView>
        </View>
      </View>
    </StyledModal >
  );
})

export default DataOptionsModal;
